export default function NotFoundPage() {
  return <div data-testid="page-not-found">404 — Page Not Found</div>;
}
